import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { stripTrailingSlash } from '../../../js/utils';
import { changeToDoingMode } from '../../../js/actions/appModeActionCreators';
import StepsNavigation from '../StepsNavigation';
import DoingPageLayout from '../PageLayout/Doing';

const WorkflowSkeleton = React.createClass({
    propTypes: {
        defaultPath: PropTypes.string.isRequired,
        location: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        alignMode: PropTypes.func.isRequired
    },
    componentDidMount: function () {
        this.props.alignMode();
        
        // TODO: make this a bit better, not that great to be doing this here.
        const currentPath = this.props.location.pathname;
        if (stripTrailingSlash(currentPath.toLowerCase()) === stripTrailingSlash((`/${this.props.route.path}`).toLowerCase())) {
            browserHistory.push(this.props.defaultPath);
        }
    },
    render: function () {
        const steps = this.props.route.childRoutes.map(route => {
            const absoluteRoutePath = `/${this.props.route.path}/${route.path}`;
            const currentPath = this.props.location.pathname;

            return {
                name: route.component.title,
                isActive: stripTrailingSlash(absoluteRoutePath.toLowerCase()) === stripTrailingSlash(currentPath.toLowerCase())
            };
        });

        return (
            <DoingPageLayout>
                <StepsNavigation steps={steps} />
                {this.props.children}
            </DoingPageLayout>
        );
    }
});

const mapDispatchToProps = (dispatch) => {
    return {
        alignMode: () => {
            dispatch(changeToDoingMode());
        }
    };
};

export default connect(null, mapDispatchToProps)(WorkflowSkeleton);


// WEBPACK FOOTER //
// ./src/components/common/WorkflowSkeleton/index.jsx